import { PrivacyPolicy as PrivacyPolicyUI } from "features";

const PrivacyPolicy = () => {
  return (
    <>
      <PrivacyPolicyUI />
    </>
  );
};
export { PrivacyPolicy };
